export const expressOrderConstants = {
    GET_ENCRYPTED_URL_VALUE: "GET_ENCRYPTED_URL_VALUE",
    GET_PLACE_DETAIL: "GET_PLACE_DETAIL",
    CREATE_ORDER: "CREATE_ORDER",
    SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
}